export default "__VITE_ASSET__0S5hdz8c__"